
/**
 * @import internal modules
 */

/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';
import * as  Particles from 'react-particles-js';
import { Link }  from 'react-router-dom'

// component
const Component: React.FunctionComponent<any> = (props: InterfaceE404<string>): JSX.Element =>{
    
   // const { classnames } = props;

    return(
        <div className="login-page" >
            <div style={{  position: "absolute", top: 0, left: 0, width: "100%",  height: "100%"}}>
            <Particles.default   params={{
                    "particles": {
                        "interactivity": {
                            "detect_on": "window",
                            "events": {
                                "onhover": {
                                    "enable": false,
                                    "mode": "repulse"
                                }
                            }
                        },
                        "number": {
                            "value": 100
                        },
                        "retina_detect": true,
                        "size": {
                            "value": 5
                        },
                        
                    }
                    
                }} />
                 <div style={{  position: "absolute", top: 0, left: 0, width: "100%",  height: "100%"}}>
                    <div className="btn-e404">
                        <div className="notfound-e404">
                        <h2 >Sorry, page not found</h2>
                        <Link className="btn-e404-btn" to="">
                            Back Home
                        </Link>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
// interface 
export interface InterfaceE404<T>{
    classnames: T,
}
/**
 * DefaultProps values
 */
Component.defaultProps= {

}


export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@pages/e404/component.tsx